import { render, staticRenderFns } from "./VStatisticPercentChange.vue?vue&type=template&id=c9051d0a&"
import script from "./VStatisticPercentChange.vue?vue&type=script&lang=js&"
export * from "./VStatisticPercentChange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c9051d0a')) {
      api.createRecord('c9051d0a', component.options)
    } else {
      api.reload('c9051d0a', component.options)
    }
    module.hot.accept("./VStatisticPercentChange.vue?vue&type=template&id=c9051d0a&", function () {
      api.rerender('c9051d0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/VStatisticPercentChange.vue"
export default component.exports